import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { InfoButton, SocialShare as UISocialShare } from 'ui'
import { ConfigService, IntlService, KwkService } from 'services'
import { showConfirm, showPrompt, setQueryInUrl } from 'utils'
import * as socialChannels from './channels'

export default function SocialShare({
  className,
  channelList,
  productArea,
  kwk,
  title,
  text,
  url,
  hideLegalInfo,
  legalUrl
}) {
  const [channels, setChannels] = useState([])

  useEffect(() => {
    if (socialChannels.share.available) {
      setChannels([socialChannels.share])
    } else {
      setChannels(channelList.map(id => socialChannels[id]).filter(Boolean))
    }
  }, [channelList])

  const share = async channel => {
    const showKwkPrompt = kwk && !KwkService.customerNumber
    const { showLegalInfo = !hideLegalInfo } = channel
    let targetUrl = url

    if (ConfigService.get('psId')) {
      targetUrl = setQueryInUrl(targetUrl, { ps_id: ConfigService.get('psId') })
    }

    if (showKwkPrompt) {
      const { confirmed, value } = await showPrompt(
        <>
          {IntlService.get('kwk.input-customer-id.text-1')}
          <div className="d-inline-flex ms-1">
            <InfoButton fade={false} text={IntlService.get('kwk.input-customer-id.info')} />
          </div>
          <br />
          {IntlService.get('kwk.input-customer-id.text-2')}
          {legalUrl && (
            <>
              <br />
              <br />
              <a href={legalUrl} target="_blank" rel="nofollow noopener noreferrer">
                Hinweise zum Datenschutz
              </a>
            </>
          )}
        </>,
        {
          pattern: '\\d+',
          title: IntlService.get('kwk.input-customer-id.title'),
          buttons: { ok: { label: IntlService.get('kwk.input-customer-id.confirm') } }
        }
      )
      if (!confirmed || !value) return

      KwkService.setCustomerNumber(value)
    }

    if (kwk) {
      targetUrl = await KwkService.createPromotionLink({ channel: channel.id, productArea })
    }

    if (showLegalInfo) {
      const { confirmed } = await showConfirm(
        IntlService.get('socialshare.legal-info.text').replace(/{channel}/g, channel.title),
        {
          title: IntlService.get('socialshare.legal-info.title'),
          buttons: { ok: { label: IntlService.get('socialshare.legal-info.confirm') } }
        }
      )
      if (!confirmed) return
    }

    const shareUrl = channel
      .createShareUrl({
        title: decodeURIComponent(IntlService.get(`socialshare.channels.${channel.id}.title`) || title),
        text: decodeURIComponent(IntlService.get(`socialshare.channels.${channel.id}.text`) || text),
        url: decodeURIComponent(targetUrl)
      })
      .replace(/%7BURL%7D/g, decodeURIComponent(targetUrl))

    if (channel.share) {
      channel.share(shareUrl)
    } else {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = shareUrl
      a.setAttribute('target', '_blank')
      a.setAttribute('rel', 'nofollow noopener noreferrer')
      a.click()
      a.remove()
    }
  }

  return (
    <UISocialShare
      className={className}
      icons={channels.map(channel => channel.iconName || channel.id)}
      onShare={icon => {
        const channel = channels.find(c => c.id === icon || c.iconName === icon)
        channel && share(channel)
      }}
    />
  )
}

SocialShare.propTypes = {
  className: PropTypes.string,
  channelList: PropTypes.arrayOf(PropTypes.string).isRequired,
  productArea: PropTypes.oneOf(['dsl', 'allnetflat', 'dataflat']),
  kwk: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  url: PropTypes.string,
  hideLegalInfo: PropTypes.bool,
  legalUrl: PropTypes.string
}

SocialShare.defaultProps = {
  channelList: ['twitter', 'facebook', 'whatsapp', 'email'],
  productArea: 'dsl',
  kwk: false,
  title: '',
  text: '',
  url: location.href,
  legalUrl: 'https://www.1und1.de/Datenschutz'
}
